import { Components, formHelperTextClasses, Theme } from '@mui/material';

export function getMuiFormHelperText(
  theme: Theme,
): Components['MuiFormHelperText'] {
  return {
    styleOverrides: {
      root: {
        marginTop: theme.spacing(3),
        fontWeight: 400,
        fontSize: 14,
        lineHeight: 1.43,
        letterSpacing: '0.01em',
        fontFeatureSettings: "'case' on, 'cv11' on, 'calt' off",
        color: theme.palette.grey[600],
        marginLeft: 0,

        [`&.${formHelperTextClasses.disabled}`]: {
          color: theme.palette.grey[400],
        },
      },
    },
  };
}
